module.exports = __webpack_public_path__ + "img/wode2.30d47067.png";